import type {
  CustomersCollection,
  CustomerWebhooksCollection,
  DisbursementMethodsCollection,
  SearchTransactionsCollection,
  TransferAccountBalancesCollection,
} from '@escrow/datastore/collections';
// eslint-disable-next-line local-rules/validate-freelancer-imports
import { createDoc } from '@freelancer/datastore/collections-testing/document-creators';
import { generateCustomerWebhookObject } from '../collections/customer-webhooks/customer-webhooks.seed';
import { generateCustomerObject } from '../collections/customers/customers.seed';
import {
  generateDisbursementMethodObject,
  generateDisbursementMethodObjects,
} from '../collections/disbursement-methods/disbursement-methods.seed';
import { generateSearchTransaction } from '../collections/search-transactions/search-transactions.seed';
import { generateTransferAccountBalanceObject } from '../collections/transfer-account-balances/transfer-account-balances.seed';

export async function createCustomerWebhook(
  ...config: Parameters<typeof generateCustomerWebhookObject>
): Promise<ReturnType<typeof generateCustomerWebhookObject>> {
  return createDoc<
    CustomerWebhooksCollection,
    typeof generateCustomerWebhookObject
  >('customerWebhooks', generateCustomerWebhookObject, ...config);
}

export async function createCustomer(
  ...config: Parameters<typeof generateCustomerObject>
): Promise<ReturnType<typeof generateCustomerObject>> {
  return createDoc<CustomersCollection, typeof generateCustomerObject>(
    'customers',
    generateCustomerObject,
    ...config,
  );
}

export async function createDisbursementMethod(
  ...config: Parameters<typeof generateDisbursementMethodObject>
): Promise<ReturnType<typeof generateDisbursementMethodObject>> {
  return createDoc<
    DisbursementMethodsCollection,
    typeof generateDisbursementMethodObject
  >('disbursementMethods', generateDisbursementMethodObject, ...config);
}

export async function createDisbursementMethods(
  ...config: Parameters<typeof generateDisbursementMethodObjects>
): Promise<ReturnType<typeof generateDisbursementMethodObjects>> {
  return createDoc<
    DisbursementMethodsCollection,
    typeof generateDisbursementMethodObjects
  >('disbursementMethods', generateDisbursementMethodObjects, ...config);
}

export async function createSearchTransaction(
  ...config: Parameters<typeof generateSearchTransaction>
): Promise<ReturnType<typeof generateSearchTransaction>> {
  return createDoc<
    SearchTransactionsCollection,
    typeof generateSearchTransaction
  >('searchTransactions', generateSearchTransaction, ...config);
}

export async function createTransferAccountBalances(
  ...config: Parameters<typeof generateTransferAccountBalanceObject>
): Promise<ReturnType<typeof generateTransferAccountBalanceObject>> {
  return createDoc<
    TransferAccountBalancesCollection,
    typeof generateTransferAccountBalanceObject
  >('transferAccountBalances', generateTransferAccountBalanceObject, ...config);
}

export async function createSearchTransactions(
  count: number,
  ...config: Parameters<typeof generateSearchTransaction>
): Promise<readonly ReturnType<typeof generateSearchTransaction>[]> {
  return Promise.all(
    Array.from({ length: count }, () => createSearchTransaction(...config)),
  );
}
